<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Alamat Email</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <div v-if="setEmail || customer.email == null">
                        <h3>Daftarkan alamat email kamu!</h3>
                        <p>Email kamu tidak akan dipublikasikan dan hanya digunakan untuk proses verifikasi akun kamu</p>
                        
                        <div class="form-group basic">
                            <label class="label">Alamat Email</label>
                            <input type="email" class="form-control" v-model="data.email" placeholder="Ketik disini" ref="email">
                        </div>
                        <div class="form-group basic">
                            <label class="label mb-1">Kode OTP</label>
                            <div class="input-group">
                                <input type="number" class="form-control" v-model="data.confirm_code" placeholder="Ketik disini">
                                <div class="input-group-append">
                                    <span class="input-group-text text-primary">
                                        <a href="Javascript:;" @click="showSender()"><small >Minta OTP</small></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic mt-1">
                            <button class="btn btn-primary btn-block btn-lg" @click="showDialog('show')">Simpan</button>
                        </div>
                    </div>
                    <div v-else-if="customer.email != null && customer.email_verified != null">
                        <h3>Selamat, alamat email kamu sudah terverifikasi!</h3>
                        <p>Email kamu tidak akan dipublikasikan dan hanya digunakan untuk proses verifikasi akun kamu.</p>
                        <blockquote class="blockquote text-center mb-2">
                            <p class="mb-0">{{ customer.email }}</p>
                        </blockquote>
                        
                        <div class="text-center">
                            <div class="chip chip-success ml-05 mb-05">
                                <span class="chip-label"><ion-icon name="checkmark-circle"></ion-icon> <b>VERIFIED</b></span>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="customer.email != null && customer.email_verified == null">
                        <h3>Menunggu proses verifikasi!</h3>
                        <p>Periksa email masuk kamu untuk menyelesaikan proses verifikasi email, jika kamu tidak menemukan email dari kami di pesan masuk, silahkan periksa di folder spam email kamu.</p>
                    
                        <blockquote class="blockquote text-center mb-2">
                            <p class="mb-0">{{ customer.email }}</p>
                        </blockquote>
                        
                        <div class="text-center">
                            <div class="chip chip-warning ml-05 mb-05">
                                <span class="chip-label"> <ion-icon name="hourglass"></ion-icon> <b>UNVERIFIED</b></span>
                            </div>
                            <p>Belum terima email? <br>
                                <a href="Javascript:;" @click="resend()"><b>KIRIM ULANG</b></a> atau <a href="Javascript:;" @click="changeEmail()"><b>GANTI EMAIL</b></a>
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="accordion" id="faq">
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#FAQ0'">
                                <b>Kenapa verifikasi email diperlukan?</b>
                            </button>
                        </div>
                        <div :id="'FAQ0'" class="accordion-body collapse" data-parent="#faq">
                            <div class="accordion-content">
                                <p>Verifikasi email diperlukan untuk kebutuhan verifikasi data kamu, jika terjadi sesuatu hal yang tidak dapat diprediksi seperiti nomor handphone hilang atau nomor handphone tidak dapat di gunakan lagi, guna untuk memulihkan akun kamu maka kami akan menggunakan alamat email kamu untuk memulihkannya.</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#FAQ1'">
                                <b>Apakah bisa merubah email sewaktu - waktu?</b>
                            </button>
                        </div>
                        <div :id="'FAQ1'" class="accordion-body collapse" data-parent="#faq">
                            <div class="accordion-content">
                                <p>Alamat email yang kamu gunakan untuk verifikasi email tidak dapat diubah kembali jika sudah melakukan verifikasi, pastikan sebelum melakukan verifikasi email kamu menggunakan alamat email yang aktif.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog ref="dialog" :loading="dialogLoading" :title="'Konfirmasi'" @confirm="submit()">
            <p>Dengan melakukan verifikasi email maka Anda menyetujui <b class="text-primary">Syarat & Ketentuan</b> dan <b class="text-primary">Kebijakan Privasi</b> yang berlaku. Apakah Anda setuju?</p>
        </Dialog>
        
        <action-sheet-sender ref="sender" :phone="customer.phone" :inset="true"></action-sheet-sender>

    </div>
</template>
<script>
import { mapState } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.email',
    data() {
        return {
            data:{
                email: '',
                confirm_code: ''
            },
            dialogLoading: false,
            loading_resend: false,
            setEmail: false,
        }
    },
    created() {
        setTimeout(() => this.$store.commit('SET_LOADING', {app:false}) , 1500)
    },
    computed: {
        ...mapState(['customer','loading','toast']),
        email: function(){
            if(this.customer.email != null && this.customer.email != ''){
                const email = this.customer.email.split("@")
                return email[0].substring(0, 1)+' ••••• @'+email[1]
            }else{
                return this.customer.email
            }
        }
    },
    methods: {
        changeEmail(){
            this.$store.commit('SET_LOADING', {app:true})
            this.data = {
                email: '',
                confirm_code: ''
            }
            this.setEmail = true
            setTimeout(() => this.$store.commit('SET_LOADING', {app:false}) , 1000)
        },
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        showSender(){
            let element = this.$refs.sender.$el
            window.$(element).modal('show')
        },
        submit(){
            this.dialogLoading = true
            $axios.post('/email', this.data)
            .then((response) => {
                this.showDialog('hide')
                this.dialogLoading = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'default',icon:'success'})
                this.setEmail = false
                this.data.email = ''
            }).catch((error) => {
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.showDialog('hide')
                this.dialogLoading = false
                
            })
        },
        resend(){
            this.$store.commit('SET_LOADING', {app:true})
            $axios.post('/email-resend')
            .then((response) => {
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.$store.commit('SET_LOADING', {app:false})
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'default',icon:'success'})
            }).catch((error) => {
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.$store.commit('SET_LOADING', {app:false})
            })
        }
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
        this.$store.commit('RESET_TOAST')
    },
}
</script>